module.exports = __webpack_public_path__ + "img/EG.9085722e.svg";